module.exports = __webpack_public_path__ + "8ae67d02e58530e20364fc04a825c436.svg";